<!--
@component

For displaying toast messages.

This is the "container" element that all toasts pushed using the
`useToast` API will be added to. Add this component near the root of
your application, like in the root layout component.

It needs access to context from `provideToast`, which should also
be added to the root layout component.
-->
<script lang="ts">
import { flip } from 'svelte/animate';
import { fade, fly } from 'svelte/transition';

import { useToastState } from './context';
import ToastBanner from './toast-banner.svelte';

const { toasts, pageIsVisible } = useToastState();
let visibilityState: DocumentVisibilityState;

$: pageIsVisible.set(visibilityState === 'visible');
</script>

<svelte:document bind:visibilityState />

<!--
  TODO(mc, 2023-01-11): "toasts" isn't a very accessible aria-label.
  Consider "messages" or "events" instead.
-->
<div
  role="status"
  aria-label="Toasts"
  class="z-max fixed top-auto bottom-0 left-1/2 -translate-x-1/2 transform pb-6"
>
  <ul class="flex flex-col items-center gap-3">
    {#each $toasts as { id, pause, resume, ...toast } (id)}
      <li
        in:fly={{ y: 64 }}
        out:fade
        animate:flip={{ duration: 200 }}
        on:mouseenter={pause}
        on:mouseleave={resume}
      >
        <ToastBanner {...toast} />
      </li>
    {/each}
  </ul>
</div>
